// Get My Creators Connected
export const GET_MY_CREATORS_CONNECTED_REQUEST = 'GET_MY_CREATORS_CONNECTED_REQUEST';
export const GET_MY_CREATORS_CONNECTED_DONE = 'GET_MY_CREATORS_CONNECTED_DONE';
export const GET_MY_CREATORS_CONNECTED_FAILED = 'GET_MY_CREATORS_CONNECTED_FAILED';
export const GET_MY_CREATORS_CONNECTED_RESET = 'GET_MY_CREATORS_CONNECTED_RESET';

// Operations
export const TOGGLE_MY_CREATORS_CONNECTED = 'TOGGLE_MY_CREATORS_CONNECTED';
export const TOGGLE_ALL_MY_CREATORS_CONNECTED = 'TOGGLE_ALL_MY_CREATORS_CONNECTED';
export const SET_MY_CREATORS_CONNECTED_FILTER = 'SET_MY_CREATORS_CONNECTED_FILTER';
export const SET_MY_CREATORS_CONNECTED_ALL_FILTERS = 'SET_MY_CREATORS_CONNECTED_ALL_FILTERS';
export const CLEAR_MY_CREATORS_CONNECTED_FILTERS = 'CLEAR_MY_CREATORS_CONNECTED_FILTERS';
export const MY_CREATORS_CONNECTED_SET_PAGE = 'MY_CREATORS_CONNECTED_SET_PAGE';